<div class="form-group">
  <div class="assignee-header">
    <label for="" class="form-label">{{label}}</label>
    @if (!isAssigned) {
    <div class="actions">
      <button class="btn btn-success" [disabled]="!isRelatedToCompany" (click)="openAssigneeModal()">
        <img src="assets/images/svg/assignee.svg" alt="" />
        إسناد
      </button>
      <button class="btn btn-cancel" [disabled]="!isRelatedToCompany" (click)="openInNewTab()">
        <img src="assets/images/svg/add-logo.svg" alt="" />
        إضافة
      </button>
    </div>
    }
  </div>
  <div class="assignee-content">
    <div class="client-values">
      <div>
        <p class="font-12 client-input-label font-semibold mb-2">مدخلات العميل:</p>
        <p class="font-16 font-bold">{{ value?.length > 0 ? value : '-' }}</p>
      </div>
      @if (isAssigned) {
      <div class="assigned font-bold">
        <img src="assets/images/svg/check-mark-icon.svg" alt="" />
        تم الإسناد
        @if (assigneeError) {
        <span class="assingee-error">{{ assigneeError }}</span>
        }
      </div>
      }
    </div>

    <div class="break-line"></div>

    @if (!isAssigned) {
    <div class="unassigned-values font-semibold">
      <img src="assets/images/svg/warning.svg" alt="" />
      <span class="no-assignee"> يجب إسناد الشركة أولاً</span>
    </div>
    } @else {
    <div class="client-values">
      <div>
        <p class="font-12 client-input-label font-semibold mb-2">
          تم الإسناد الي:
        </p>
        <p class="font-16 font-bold">{{assigneeObj.name}}</p>
      </div>
      <div>
        <img src="assets/images/svg/edit.svg" class="pointer mx-3" alt="edit-icon" (click)="openAssigneeModal()" />
        <img src="assets/images/svg/link-broken.svg" class="pointer" alt="unlink-icon" (click)="unlinkAssignee()"/>
      </div>
    </div>
    }
    </div>
  </div>
